import { ActionButton } from "../../../components/Forms/ActionButton";
import { TextArea } from "../../../components/Forms/TextArea";
import Heading from "../../../components/Heading";
import { useEffect, useState } from "react";
import InputField from "../../../components/Forms/InputField";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from "react-router-dom";
import MediaUpload from "../../../components/Forms/MediaUpload";
import { createEventCategory, eventsCategoryEditView, updateEventCategory } from "../../../api/events";
import ActiveStatus from "../../../components/Common/ActiveStatus";
import { useHeader } from "../../../context/HeaderContext";

const CreateEventCategory = () => {

    const { state } = useLocation();
    const navigate = useNavigate();
    
    const { setHeaderTitle } = useHeader();
    
      useEffect(() => {
        setHeaderTitle('Create Event Category');
        return () => {
          setHeaderTitle('');
        };
      }, [setHeaderTitle]);
    
    const [ data, setData ] = useState([
        { label: 'Name Of Category', placeholder: 'Enter Name Of Category', name: 'name', value: '', type: 'text' },
        { label: 'Description', placeholder: 'Enter Description Of Category', name: 'description', value: '', type: 'textarea' },
    ]);

    const [ active, setActive ] = useState(true);
    const [ image, setImage ] = useState(null);
    const [ clearMedia, setClearMedia ] = useState(false);
    
    const handleChange = (index, newValue) => {
        setData(prevFields => prevFields.map((field, i) => i === index ? { ...field, value: newValue } : field));
    }
    
    // const getAndUpload = async (file) => {
    //     if (!file) return;
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //         setImage(reader.result);
    //     };
    // };
    
    const handleSubmit = e => {
        e.preventDefault();
        if(state?._id){
            updateEventCategory(state._id, {
                name: data[0].value,
                description: data[1].value,
                active: active,
            }, image, toast, navigate);
        }
        else {
            createEventCategory({
                name: data[0].value,
                description: data[1].value,
                active: active,
            }, image, toast, navigate);
        }
    }
    
    // useEffect(() => {
    //     if (image) {
    //         // setImage(image);
    //         getAndUpload(image);
    //     }
    //     else {
    //         setImage(null);
    //     }
    // }, [image]);

    useEffect(() => {
        if(image) {
            setClearMedia(false);
        }
    }, [image]);
    
    useEffect(() => {
        if(state?._id) eventsCategoryEditView(state._id, data, setData, setActive, setImage, toast);
        // eslint-disable-next-line
    }, []);
    
    return (
        <form className="flex flex-col w-full font-semibold">
            
            <div className="flex justify-end mb-3">
                <ActiveStatus active={active} setActive={setActive} />
            </div>
            
            <section className="flex flex-col justify-center px-5 pt-4 py-9 gap-3 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">

                <div className="flex w-full gap-3">
                    <div className="w-full mt-2.5">
                        <div className="flex flex-wrap gap-5 items-end w-full justify-between">
                            <InputField
                                label={data[0].label}
                                placeholder={data[0].placeholder}
                                name={data[0].name}
                                value={data[0].value}
                                type={data[0].type}
                                onChange={e => handleChange(0, e.target.value)}
                            />
                            {/* <div className={`flex justify-end items-center border ${active ? `border-primary` : `border-inactive`} rounded-md h-full min-h-12 min-w-36`}>
                                <label className="inline-flex items-center me-5 cursor-pointer h-full">
                                    <span className={`ms-3 text-base ${active ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{active ? 'Active' : 'Inactive'}</span>
                                    <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                                    <div className="relative w-11 h-6 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                                </label>
                            </div> */}
                        </div>
                        <TextArea
                            minHeight={'180px'}
                            label={data[1].label}
                            placeholder={data[1].placeholder}
                            name={data[1].name}
                            value={data[1].value}
                            type={data[1].type}
                            onChange={e => handleChange(1, e.target.value)}
                        />
                    </div>
                    {/* Category Logo Section */}
                    <div className="mt-0">
                        {/* <ImageInput
                            image={image}
                            setImage={setImage}
                            text={'Category Logo'}
                        /> */}
                        <MediaUpload
                            label="Category Logo"
                            id="categoryLogo"
                            setImageUpload={setImage}
                            existingImage={image}
                            stateImage={image}
                            setStateImageUpload={setImage}
                            clearMedia={clearMedia}
                            useFileObject={true}
                        />
                    </div>
                </div>

                <div className="flex mt-10 gap-3 items-center justify-between self-stretch my-auto whitespace-nowrap min-w-[240px] w-full">
                    <ActionButton
                        variant="reset"
                        text="Reset"
                        handleSubmit={() => {
                            setData([
                                { label: 'Name Of Category', placeholder: 'Enter Name Of Category', name: 'name', value: '', type: 'text' },
                                { label: 'Description', placeholder: 'Enter Description Of Category', name: 'description', value: '', type: 'textarea' },
                            ]);
                            setActive(true);
                            setImage(null);
                            setClearMedia(true);
                        }}
                    />
                    <div className="flex gap-3">
                        <ActionButton variant="cancel" text="Cancel" handleSubmit={() => navigate('/events/event-categories/view-categories')} />
                        <ActionButton variant="submit" text="Submit" handleSubmit={handleSubmit} />
                    </div>
                </div>
                
            </section>
            <ToastContainer
                position="top-right"
            />
        </form>
    );
}

export default CreateEventCategory;